module.exports = __webpack_public_path__ + "static/img/logo.552c274.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo.gif
// module id = AhVH
// module chunks = 0